import { generateGruserObjectId } from '../helpers';
import { createSelector } from 'reselect';
export const getCurrentGruserSlice = createSelector((state)=>state['@@gruser'], (_, gruser)=>gruser, (state, gruser)=>{
    if (!gruser) {
        return {};
    }
    return state.grusers[generateGruserObjectId(gruser)];
});

//# sourceMappingURL=grusers.js.map